import React from "react";
import "./style.scss";

export const Input = ({
  className,
  containerClassName,
  placeholder,
  required = false,
  onChange,
  value,
  title,
  type = "text",
  disabled = false,
  autoFocus = false,
  icon,
}) => {
  return (
    <div className={`input_container_parent ${containerClassName || ""}`}>
      {title && (
        <p className="title">
          {title}
          {required && <span className="required">*</span>}
        </p>
      )}
      <div className="input_container">
        <input
          type={type}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          autoFocus={autoFocus}
          className={`input ${className || ""}`}
          value={value}
          placeholder={placeholder || ""}
        />
        {icon && <span className="left_icon">{icon}</span>}
      </div>
    </div>
  );
};
